"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.defaultButtonStyles = function (props) {
  return "\n" + props.theme.font.label.v200 + "\n  box-sizing: border-box;\n  background: transparent;\n  position: relative;\n  margin: 0;\n  padding: 0 20px;\n  color: inherit;\n  min-height: " + (props.size === 'medium' ? '40px' : '56px') + ";\n  border-radius: " + props.theme.border.radius + ";\n  min-width: 160px;\n  font-weight: " + props.theme.font.weight.v300 + ";\n  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  border: 1px solid transparent;\n  cursor: pointer;\n  outline: none;\n  user-select: none;\n  align-items: center;\n  vertical-align: middle;\n  justify-content: center;\n  text-decoration: none;\n  appearance: none;\n  font-family: " + props.theme.font.family + ";\n  text-transform: uppercase;\n  font-feature-settings: 'cpsp' on, 'liga' off;\n\n  &:focus { outline: none; }\n\n  &:disabled {\n    background: " + props.theme.color.neutral.v300 + ";\n    color: " + props.theme.color.neutral.v100 + ";\n    pointer-events: none;\n    cursor: default;\n    border-color: transparent;\n  }\n";
};

exports.DefaultButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), exports.defaultButtonStyles);
var templateObject_1;